module.exports = __webpack_public_path__ + "static/UnclickTravelInconvenienceYellow-2ab62eff11b35c14867f2283ea2d16aa.png";